import { Component, OnInit } from '@angular/core';
import {Page} from '../../model/page';
import {FormControl} from '@angular/forms';
import {VendorService} from '../../services/vendor.service';
import {CompanyService} from '../../services/company.service';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {Observable} from 'rxjs/Observable';
import {Company} from '../../model/company';
import {Vendor} from '../../model/vendor';
import {GridFiltersService} from '../../services/grid.filters.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-merge-vendors',
    templateUrl: './merge-vendors.component.html',
    styleUrls: ['./merge-vendors.component.scss'],
    providers: [
        GridFiltersService
    ]
})

export class MergeVendorsComponent implements OnInit {

    public scrollHeight = '290px';
    public loading = false;
    public page = new Page();
    rows = new Array<Vendor>();
    cols = [];
    totalRecords = 0;
    vendorPageSize = 10;

    private filters: { [key: string]: string; } = {};

    private allCompany = {
        'CO1_ID': null,
        'CO1_NAME': '#SelectCompany#'
    };

    private allVendors  = {
        'VD1_ID': 0,
        'VD1_NAME': '#SelectVendor#'
    };

    public companyCtrl: FormControl = new FormControl();
    public vendorCtrl: FormControl = new FormControl();
    public companyFilterCtrl: FormControl = new FormControl();
    public vendorFilterCtrl: FormControl = new FormControl();
    public filteredCompanies: any[] = [];
    public filteredValues: any[] = [];
    public toVendors: any[] = [];
    public fromVendors: any[] = [];
    public duplicateCompaniesIsChecked = false;

    private companies:   Array<any> = [this.allCompany];
    private vendors:   Array<any> = [this.allVendors];
    private toVendorsValues:   Array<any> = [];
    public hasVendors = false;
    public errors: any = {};

    CO1_ID = 0;
    VD1_ID = 0;
    companyControl = new FormControl();
    vendorControl = new FormControl();

    selectedCompany: any = {
        'CO1_ID': null,
        'CO1_NAME': '',
    };
    selectedVendor: any = {
        'VD1_ID': 0,
        'VD1_NAME': '',
    };

    constructor(
        private vendorService: VendorService,
        private companyService: CompanyService,
        private toastr: ToastrService,
        public  dialog: MatDialog,
        private router: Router,
        private confirmationService: ConfirmationService,
        private gridFiltersService: GridFiltersService,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.title.setTitle('Admin - Merge Vendors');
    }

    ngOnInit() {
        this.loading = true;
        this.cols = [
            { field: 'checkbox',                 header: '',              visible: true, width: '40px' },
            { field: 'VD1_ID',                   header: 'ID',            visible: true, width: '30px' },
            { field: 'VENDOR_ID',                header: 'Vendor Id',     visible: true, width: '70px' },
            { field: 'VD1_TEST_MODE',            header: 'Test Mode',     visible: true, width: '60px' },
            { field: 'VD1_SHOW_DEFAULT',         header: 'Show Default',  visible: true, width: '70px' },
            { field: 'VD1_NAME',                 header: 'Vendor',        visible: true, width: '150px' },
            { field: 'VD1_TRANSACTION_TOTALS',   header: 'Trans.',        visible: true, width: '70px' },
            { field: 'VD1_SHIPMENT_TOTALS',      header: 'Ships',         visible: true },
            { field: 'VD1_SHIPMENT_LINE_TOTALS', header: 'Ship Lines',    visible: true },
            { field: 'VD1_PO_TOTALS',            header: 'POs',           visible: true },
            { field: 'VD1_PO_LINE_TOTALS',       header: 'PO Lines',      visible: true },
            { field: 'VD1_INV_TOTALS',           header: 'INVs',          visible: true },
            { field: 'VD1_INV_LINE_TOTALS',      header: 'INV Lines',     visible: true }
        ];
        this.setPage();
    }

    setPage() {
        this.serverCall(this.page).subscribe(result => {
                this.companies = result.data;
                this.getCompanies();
                this.loading = false;
            },
            error => {
                console.log(error);
                this.loading = false;
                this.toastr.error('Companies loading error occured', 'Service Error', {
                    timeOut: 3000,
                });
            });
    }

    getCompanies() {
        this.companies = this.companies.filter(v => v['CO1_NAME'] && v['CO1_NAME'] !== '');
        const me = this;
        if (this.CO1_ID) {
            this.selectedCompany = this.companies.filter( item => {
                return Number(item['CO1_ID']) === me.CO1_ID;
            })[0];
        }
        this.clearVendors();
        this.filterCompanies();
    }

    duplicateCompanies(e) {
        if (e.checked) {
            this.duplicateCompaniesIsChecked = true;
        } else {
            this.duplicateCompaniesIsChecked = false;
        }
        this.hasVendors = false;
        this.CO1_ID = 0;
        delete this.page.filterParams.CO1_ID;
        this.page.size = 0;
        this.clearVendors();
        this.setPage();
    }

    serverCall(page: Page): Observable<any> {
        if (this.duplicateCompaniesIsChecked) {
            return this.companyService.getDuplicateCompanies(this.page);
        } else {
            return this.companyService.getCompanies(this.page);
        }
    }

    companyChanged(e) {
        this.CO1_ID = Number(e.value['CO1_ID']);
        this.clearVendors();
        this.getVendors();
    }

    clearVendors() {
        this.toVendorsValues = [];
        this.VD1_ID = 0;
        this.vendors = [{
            'VD1_ID': 0,
            'VD1_NAME': ''
        }];
        this.errors = {};
    }

    filterCompanies() {
        if (!this.companies) {
            return;
        }
        let search = this.companyFilterCtrl.value;
        if (!search) {
            this.filteredCompanies = this.companies;
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the companies
        this.filteredCompanies = this.companies.filter(
            company => company.CO1_NAME && company.CO1_SHOW_DEFAULT === 'X' && company.CO1_NAME.toLowerCase().indexOf(search) > -1);
    }

    filterVendors() {
        if (this.vendors.length === 0) {
            this.hasVendors = false;
            return;
        }
        this.hasVendors = true;
        this.filteredValues = this.vendors;
        this.toVendors = this.filteredValues;
        this.fromVendors = this.filteredValues;
    }

    getVendors() {
        this.loading = true;
        this.page.size = this.vendorPageSize;
        this.page.filterParams['CO1_ID'] = this.CO1_ID;
        this.page.filterParams['calculateUsage'] = true;
        this.vendorService.getVendors(this.page).subscribe(result => {
                this.vendors = result.data.map( (item: any) => {
                    item['VD1_ID'] = Number(item['VD1_ID']);
                    return item;
                });
                this.filterVendors();
                this.loading = false;
            },
            error => {
                this.loading = false;
                this.toastr.error('Vendors loading error occured', 'Service Error', {
                    timeOut: 3000,
                });
            });

    }

    changeFromVendor(e, value) {
        const val = Number(value);
        if (e.checked) {
            this.toVendorsValues.push(val);
        } else {
            const index = this.toVendorsValues.indexOf(val);
            this.toVendorsValues.splice(index, 1);
        }
        this.toVendors = this.filteredValues.filter(
            vendor => !this.toVendorsValues.includes(vendor.VD1_ID));
    }

    vendorIsChecked(value) {
        return this.toVendorsValues.includes(value);
    }

    hasDuplicate(VD1_ID: any, VD1_NAME: any) {
        const vendors = this.fromVendors.filter(
            vendor => ((vendor.VD1_NAME === VD1_NAME) && (vendor.VD1_ID !== Number(VD1_ID))));
        return  vendors.length;
    }

    vendorChanged(e) {
        this.VD1_ID = Number(e.value['VD1_ID']);
        this.fromVendors = this.filteredValues.filter(
            vendor => vendor.VD1_ID !== this.VD1_ID);
    }

    mergeVendorConfirm() {
        this.errors = {};
        if (this.VD1_ID === 0) {
            Object.assign(this.errors, {to_vendor: 'To cannot be blank'});
        }
        if (this.toVendorsValues.length === 0) {
            Object.assign(this.errors, {from_vendor: 'From cannot be blank'});
        }
        if (Object.keys(this.errors).length === 0) {
            this.confirmationService.confirm({
                message: 'Are you sure you want to execute merge operation?',
                accept: () => {
                    this.loading = true;
                    this.vendorService.merge({
                        CO1_ID: this.CO1_ID,
                        VD1_FROM_IDs: this.toVendorsValues,
                        VD1_TO_ID: this.VD1_ID
                    }).subscribe( (result: any) => {
                        if (result.data.success) {
                            this.loading = false;
                            this.toVendorsValues = [];
                            this.getVendors();
                        }
                    });
                }
            });
        }
    }

    filterFromCustomers() {

        if (this.vendors.length === 0) {
            return;
        }
        let search = this.vendorFilterCtrl.value;
        if (search) {
            search = search.toLowerCase()
            this.fromVendors = this.vendors.filter(
                vendor => (vendor.VD1_NAME.toLowerCase().indexOf(search) > -1) && (vendor.VD1_ID !== this.VD1_ID));
        } else {
            this.fromVendors = this.vendors.filter(
                vendor => (vendor.VD1_ID !== this.VD1_ID));
        }

    }

    filterToVendors() {
        if (this.vendors.length === 0) {
            return;
        }
        let search = this.vendorFilterCtrl.value;
        if (search) {
            search = search.toLowerCase()
            this.toVendors = this.vendors.filter(
                vendor => vendor.VD1_NAME.toLowerCase().indexOf(search) > -1 && !this.toVendorsValues.includes(vendor.VD1_ID));
        } else {
            this.toVendors = this.vendors.filter(
                vendor => !this.toVendorsValues.includes(vendor.VD1_ID));
        }
    }

    onColResize(event) {

    }

    onPage(event) {
        this.vendorPageSize = event.rows;
        this.getVendors();
    }

    onRowExpand(event) {

    }


}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/merge-vendors/merge-vendors.component.ts